import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { IdexService } from 'app/idex.service';
import { DropboxListComponent } from '../dropbox-list/dropbox-list.component';
import { Path } from 'app/shared/path';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDeleteComponent } from '../confirm-delete/confirm-delete.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CreateFolderComponent } from '../create-folder/create-folder.component';
import { CreateDropboxComponent } from '../dropbox/create-dropbox.component';
import {Toast} from '../../shared/toast/toast';
import { UploadProgressComponent } from '../upload-progress/upload-progress.component';
import { DropboxUploaderService } from '../dropbox-uploader.service';

@Component({
  selector: 'app-dropbox-page',
  templateUrl: './dropbox-page.component.html',
  styleUrls: ['./dropbox-page.component.css']
})
export class DropboxPageComponent implements OnInit, OnDestroy {
  @ViewChild(DropboxListComponent, { static: true }) dropboxList: DropboxListComponent;
  @ViewChild('toolbar') toolbar: ElementRef;
  @ViewChild('progress') progress: UploadProgressComponent;

  selectedItems: any[] = [];

  paths = [];
  drivePaths: any[] = [];

  private path: string;
  private drivePath: string;
  public canDrag = true;
  access_token: string;

  private cursor: string = '';
  private hasMore: boolean = false;
  private currId = 0;
  private size = 50;
  supportFolderUpload = true;

  position = 'below';
  type = 'dropbox';
  private subscriber: Subscription;

  private uploadCallback = {
    init: (files) => {
       this.progress.init(files);
    },
    initFolder: (folder, name:string) => {
       this.progress.initFolder(folder, name);
    },
    progress: (i: number, progress: number) => {
       this.progress.update(i, progress);
    },
    cancelUpload: (i: number, error: string) => {
       this.progress.cancelUpload(i, error);
    },
    complete: () => {
       const result = this.progress.complete();

       setTimeout(() => {
          this.progress.hide();
          var nowPath = localStorage.getItem('url').split('/');
          if(nowPath[1] === 'dropboxPage') {
             const url = Path.combine('/dropboxPage', encodeURIComponent(this.path));
             this.router.navigate([url], {state: {drivePaths: this.drivePaths}});
          }
          this.initDocument(this.path);

       }, this.progress.calcDelay());
    }
 };

  constructor(private router: Router, private route: ActivatedRoute, private translate: TranslateService,
    private toast: Toast, private dialog: MatDialog, private service: IdexService,
    private renderer: Renderer2, private dropboxService: DropboxUploaderService) {
  }

  ngOnInit(): void {
    this.dropboxList.loadData = false;
    this.route.queryParams.subscribe(params => {
      if (params['fileId']) {
        this.drivePath = JSON.parse(params['fileId']);
      } else {
        this.drivePath = 'root';
      }
    });

    this.subscriber = this.route.url.subscribe(url => {
      this.path = decodeURIComponent(url.join('/'));
      if (history.state.drivePaths) {
        this.drivePaths = history.state.drivePaths;
      } else if (this.path.length !== 0) {
        const array = this.path.match(/[^/]+/g);
        this.drivePaths = this.drivePaths.slice(0, array.length);
      }
      this.createBreadcrumb();
      if (localStorage.getItem('access_token_dropbox')) {
        this.access_token = localStorage.getItem('access_token_dropbox');
        this.initDocument(this.path);
        this.dropboxList.items = undefined;
        this.dropboxList.access_token = this.access_token;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriber.unsubscribe();
  }

  private createBreadcrumb(): void {
    this.translate.get('main.dropbox').subscribe(files => {
      if (this.path.length === 0) {
        this.paths = [{ name: files }];
        this.dropboxList.paths = this.paths;
        return;
      }
      const paths = [];
      paths.push({ name: files });

      let fullPath = '';
      const array = this.path.match(/[^/]+/g);
      for (let i = 0; i < array.length; i++) {
        if (i === array.length - 1) {
          fullPath = null;
        } else {
          if (fullPath.length > 0) {
            fullPath += '/';
          }
          fullPath += array[i];
        }
        paths.push({ name: array[i], path: fullPath });
      }
      this.paths = paths;
      this.dropboxList.paths = this.paths;
    });
  }

  showDocument(path: string) {
    this.selectedItems = [];
    this.service.getListFileDropboxWithCursor(this.access_token, path, this.size, this.hasMore, this.cursor).subscribe(r => {
      if (r.entries) {
        this.hasMore = r.hasMore;
        this.cursor = r.cursor;
        r.entries.forEach(obj => {
          obj.id = ++this.currId;
        });
        this.dropboxList.addItems(r.entries);
        this.dropboxList.hasMore = this.hasMore;
      }
    });
  }

  initDocument(path: string) {
    this.dropboxList.loadData = true;
    this.currId = 0;
    this.hasMore = false;
    this.cursor = '';
    this.service.getListFileDropboxWithCursor(this.access_token, path, this.size, this.hasMore, this.cursor).subscribe(r => {
      if (r.entries) {
        this.hasMore = r.hasMore;
        this.cursor = r.cursor;
        r.entries.forEach(obj => {
          obj.id = ++this.currId;
        });
        this.dropboxList.setItems(r.entries);
        this.dropboxList.hasMore = this.hasMore;
        this.dropboxList.loadData = false;
      }
    });
  }

  @HostListener('window:scroll')
  scrollFixed() {
    this.toolbar.nativeElement.style.left = (240 - window.scrollX) + 'px';
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (this.hasMore) {
        if (window.innerHeight + window.pageYOffset + 1 >= document.body.scrollHeight) {
          this.showDocument(this.path);
        }
      }

    }
  }

  onClickItem(item: any) {
    let path = location.pathname;
    const idex = '/idex';
    if (path.startsWith(idex)) {
      path = path.substring(idex.length);
    }

    localStorage.setItem('url', Path.combine(path));
    const fileName = item.name.toLowerCase();
    if (item.mimeType === 'application/octet-stream' && !fileName.endsWith('.web') && !fileName.endsWith('.amp') && !fileName.endsWith('.zdox')) {
       const url = Path.combine('/dropboxPage', encodeURIComponent(this.path), encodeURIComponent(item.name));
       this.drivePaths.push(encodeURIComponent(item.id));
       this.router.navigate([url], {state: {drivePaths: this.drivePaths}, queryParams: {'fileId': JSON.stringify(item.id)}});
    } else if (item.mimeType === 'application/octet-stream' && fileName.endsWith('.zdox')) {
      const accessToken = localStorage.getItem('access_token_dropbox');
      const refreshToken = localStorage.getItem('refresh_token_dropbox')
      this.service.getEFormByXml('dropbox', { access_token: accessToken, refresh_token: refreshToken, path: item.pathDisplay, name: item.name}).subscribe((res) => {
        let url = location.origin + this.router.createUrlTree(['/eform/create/view/file']);
        if (res?.data) {
           let form = res.data;
           localStorage.setItem('form-type', 'view');
           localStorage.setItem('filename', fileName);
           localStorage.setItem('form-view', JSON.stringify(form));
           localStorage.setItem('isOpenFile', "true");
           window.open(url, '_blank');
        }
     });
    } else {
      let accessToken = localStorage.getItem('access_token_dropbox');
      this.service.getShareLinkDropbox(accessToken, item.pathDisplay,).subscribe(res => {
          window.open(res.url);
      }, (error) => {
          this.translate.get('dropbox.verified_error').subscribe(s => {
            this.toast.error(s);
          });
      });
    }
  }

  navigate(path) {
    if (path.path) {
      const url = Path.combine('/dropboxPage', encodeURIComponent(path.path));
      this.router.navigate([url], {
        state: { drivePaths: this.drivePaths },
        queryParams: { 'fileId': JSON.stringify(this.drivePaths[this.drivePaths.length - 1]) }
      });
    } else {
      this.router.navigate(['/dropboxPage']);
    }
  }

  protected async onClickDelete(item: any) {
    if (!item) return;

    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      disableClose: true,
      data: {
        item: item,
        message: await this.translate.get("dropbox.message.delete").toPromise()
      }
    });
    dialogRef.afterClosed().subscribe((isConfirmDelete) => {
      if (!isConfirmDelete) return;
      this.deleteItem(this.access_token, item);
    });
  }

  protected onClickRename(item: any) {
    this.dropboxList.disabled = true;
    const body = {
      'token' : localStorage.getItem("access_token_dropbox"),
      'refreshToken' : localStorage.getItem("refresh_token_dropbox"),
      'pathDisplay' : item.pathDisplay,
      'pathNew' : item.pathDisplay,
      'name': item.name,
      'newName': item.newName };
    this.service.dropBoxUpdateFile(body).subscribe(res => {
        item.pathDisplay = res.metadata.pathDisplay;
        item.pathLower = res.metadata.pathLower;
        item.name = res.metadata.name;
        this.dropboxList.endRename(item);
        this.dropboxList.disabled = false;
    });
  }

  private deleteItem(access_token: string, item: any): void {
    this.dropboxList.loadData = true;
    this.service.dropboxDelete(access_token, item.pathDisplay).subscribe(
      (res) => {
        this.initDocument(this.path);
        this.translate.get('alert.confirm_delete').subscribe(s => {
          this.toast.success(s);
        });
      },
      (error) => {
        this.dropboxList.loadData = false;
        if (error.status === 401) {
          this.router.navigate(["/login"]);
        }
      },
      () => {
        this.dropboxList.loadData = false;
      }
    );
  }

  newFolder() {
    this.canDrag = false;
    const dialogRef = this.dialog.open(CreateFolderComponent, {
       disableClose: true,
       data: this,

    });
    dialogRef.componentInstance.toast = this.toast;
    dialogRef.componentInstance.translate = this.translate;
    dialogRef.afterClosed().subscribe(result => {
      this.canDrag = true;
    });
 }

  startGoogle(type: any) {
    this.canDrag = false;
    const google = this.dialog.open(CreateDropboxComponent, {
      disableClose: true,
      data: {
        filesComponent: this,
        path: this.path,
        type: type
      }
    });
    google.componentInstance.path = this.path;
    google.componentInstance.isBusiness = false;
    google.afterClosed().subscribe(result => {
      this.canDrag = true;
    });
  }

   protected async uploadSelected(myFiles: any,isFolder: boolean,hasPath?: boolean,paths?: any[]) {
    let filePaths = [];
    let tempFiles = [];
    for (const file of myFiles) {
      if (file.name !== '.DS_Store'){
        tempFiles.push(file);
      }
    }
    if (!hasPath) {
      if (!isFolder) {
        tempFiles = this.changeDuplicateFileNames(tempFiles, await this.getOldFileList());
      }
      for (const file of tempFiles) {
        let filePath = this.path;
        if (file.webkitRelativePath) {
          let arr = file.webkitRelativePath.split('/');
          for (let i=0;i<arr.length-1;i++) {
            filePath += '/' + arr[i];
          }
          filePaths.push(filePath);
        }
      }
      if (filePaths.length === 0) {
        filePaths.push(this.path);
      }
    } else {
      if(paths) {
        filePaths = paths;
      }
    }
    this.dropboxService.process(this.access_token, tempFiles, this.uploadCallback, filePaths );
  }

  async uploadDragDrop(myFiles: any,hasPath?: boolean,paths?: any[]) {
    let filePaths = [];
    let tempFiles = [];
    let i = 0;
    for (const file of myFiles) {
        tempFiles.push(file);
    }
    if (!hasPath) {
      for (const file of tempFiles) {
        let filePath = this.path;
        if (file.webkitRelativePath) {
          let arr = file.webkitRelativePath.split('/');
          for (let i=0;i<arr.length-1;i++) {
            filePath += '/' + arr[i];
          }
          filePaths.push(filePath);
        }
      }
      if (filePaths.length === 0) {
        filePaths.push(this.path);
      }
    } else {
      if(paths) {
        filePaths = paths;
      }
    }
    this.dropboxService.process(this.access_token, tempFiles, this.uploadCallback, filePaths );
  }

  async getOldFileList() {
    let oldList = [];
    let promise = await this.service.getListFileDropbox(this.access_token,this.path).toPromise()
      .then(res => {
        oldList = res.entries.filter(item => item.mimeType != 'application/octet-stream');
    });
    return oldList;
 }

 changeDuplicateFileNames(uploadFiles:File[], duplicateFile:any[]): File[] {
    for (let i = 0; i < uploadFiles.length; i++) {
       let counter = 1;
       let originalName = uploadFiles[i].name;
       let newName = originalName;

       while (duplicateFile.find(file => file.name === newName)) {
          newName = `${originalName.split('.')[0]} (${counter}).${originalName.split('.')[1]}`;
          counter++;
      }

      if (newName !== originalName) {
          Object.defineProperty(uploadFiles[i], 'name', {
              writable: true,
              value: newName
          });
      }
    }
    return uploadFiles;
  };

  changeDuplicateFileName(uploadFile: File, duplicateFile:any[]): File {
       let counter = 1;
       let originalName = uploadFile.name;
       let newName = originalName;

       while (duplicateFile.find(file => file.name === newName)) {
          newName = `${originalName.split('.')[0]} (${counter}).${originalName.split('.')[1]}`;
          counter++;
      }

      if (newName !== originalName) {
          Object.defineProperty(uploadFile, 'name', {
              writable: true,
              value: newName
          });
      }
      return uploadFile;
  };

  onDragOver(event: DragEvent) {
       const data = event.dataTransfer;
       let hasFiles = false;
       if (data.items) {
          for (let i = 0; i < data.items.length; i++) {
             if (data.items[i].kind === 'file') {
                hasFiles = true;
                break;
             }
          }
       } else if (data.files && data.files.length > 0) {
          hasFiles = data.files && data.files.length > 0;
       }

  }

  onDragLeave() {
      this.renderer.removeClass(this.dropboxList.nativeElement, 'drag-over');
  }

  readEntriesAsync(reader) {
    return new Promise((resolve, reject) => {
        reader.readEntries(entries => {
            resolve(entries);
        }, error => reject(error));
    })
  }

  async readDirectory(directoryEntry: any,that: any) {
    let reader = directoryEntry.createReader();
    let resultEntries = [];
    let read = async function() {
        let entries = await that.readEntriesAsync(reader);
        if (entries.length > 0) {
            resultEntries = resultEntries.concat(entries);
            await read();
        }
    }
    await read();
    return resultEntries;
  }

  async getFile(fileEntry: any) {
    return new Promise((resolve, reject) => fileEntry.file(resolve, reject));
  }

  async traverseFileTree(item: any,path: string,tempFiles: any[],paths: any[]){
    path = path || "";
    if (item.isFile && item.name !== '.DS_Store') {
      let file = await this.getFile(item);
      tempFiles.push(file);
      paths.push(path);
    } else if (item.isDirectory) {
      let entries = await this.readDirectory(item, this);
      for (let i=0;i < entries.length; i++) {
        this.traverseFileTree(entries[i], path + "/" + item.name + "/",tempFiles,paths);
      }
    }
  }

  onDrop(e: DragEvent) {
      e.preventDefault();
      e.stopPropagation();

      var items = e.dataTransfer.items;

      let tempFiles = [];
      let tempPaths = [];

      for (var i=0; i<items.length; i++) {
        var item = items[i].webkitGetAsEntry();
        this.traverseFileTree(item,this.path,tempFiles,tempPaths);
      }

      setTimeout(()=>{
        if (tempFiles.length > 0) {
          this.uploadDragDrop(tempFiles,true,tempPaths)
        }
      }, 500);
  }

}
